module.exports = __webpack_public_path__ + "img/logo-login.17776e5c.png";